import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import AdminFunnelDashboardPage from "@/pages/AdminFunnelDashboardPage";
import AdminEventsPage from "@/pages/AdminEventsPage";
import AdminAutomationPage from "@/pages/AdminAutomationPage";
import AdminMessagesPage from "@/pages/AdminMessagesPage";
import AdminUserDetailPage from "@/pages/AdminUserDetailPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import LessonPage from "@/pages/LessonPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CourseFullPage from "@/pages/CourseFullPage";
import BridgeFullCoursePage from "@/pages/BridgeFullCoursePage";
import MembersAreaPage from "@/pages/MembersAreaPage";
import CoursesIndexPage from "@/pages/CoursesIndexPage";
import LoginPage from "@/pages/LoginPage";
import ImpostaPasswordPage from "@/pages/ImpostaPasswordPage";
import AutoLoginPage from "@/pages/AutoLoginPage";
import SalesLessonPage from "@/pages/SalesLessonPage";
import CoachingBundlePage from "@/pages/CoachingBundlePage";
import UnlockFreePage from "@/pages/UnlockFreePage";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import { Toaster } from "@/components/ui/sonner";

// Legacy URL redirects (so old links keep working after the route rename).
function LegacyLessonRedirect() {
  const { n } = useParams();
  return <Navigate to={`/corso/lezione/${n}`} replace />;
}

// Keyed by lesson number: forces a FULL remount when navigating between
// lessons (L1 → L2). Without it the component instance is reused, so the
// Vimeo iframe/player and the started/completed tracking refs go stale
// (black video + missing lesson_N_started events on the next lesson).
function KeyedLessonPage() {
  const { n } = useParams();
  return <LessonPage key={n} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* MARKETING — landing kept on /, no app logic injected here */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* WEB APP — course delivery container */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/imposta-password" element={<ImpostaPasswordPage />} />
          <Route path="/corso/auto-login" element={<AutoLoginPage />} />
          <Route path="/corso" element={<CoursesIndexPage />} />
          <Route path="/corso/area-membri" element={<MembersAreaPage />} />
          <Route path="/corso/lezione/:n" element={<KeyedLessonPage />} />
          <Route path="/corso/bridge" element={<BridgeFullCoursePage />} />
          <Route path="/vendita/coaching-completo" element={<CoachingBundlePage />} />
          <Route path="/vendita/:lesson" element={<SalesLessonPage />} />
          <Route path="/sblocco-gratuito/:kind" element={<UnlockFreePage />} />
          <Route path="/corso/completo" element={<CourseFullPage />} />

          {/* CHECKOUT */}
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />

          {/* ADMIN */}
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
          <Route path="/admin/dashboard" element={<AdminFunnelDashboardPage />} />
          <Route path="/admin/eventi" element={<AdminEventsPage />} />
          <Route path="/admin/automazioni" element={<AdminAutomationPage />} />
          <Route path="/admin/messaggi" element={<AdminMessagesPage />} />
          <Route path="/admin/utente/:userId" element={<AdminUserDetailPage />} />

          {/* LEGACY redirects (kept so external links and old emails don't break) */}
          <Route path="/lesson/:n" element={<LegacyLessonRedirect />} />
          <Route path="/bridge/full-course" element={<Navigate to="/corso/bridge" replace />} />
          <Route path="/course" element={<Navigate to="/corso/area-membri" replace />} />
          <Route path="/full-course" element={<Navigate to="/corso/area-membri" replace />} />
        </Routes>
        <CookieConsentBanner />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
